import StockoutModelPanel from './stockoutModelPanel.container';

export default StockoutModelPanel;